export default __webpack_public_path__ + "b4ac4bd2ca184bfdaf7b455a9f6ceb70.png";